import { CommonModule } from "@angular/common";
import { Component, inject, input, signal, Signal } from "@angular/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { Router } from "@angular/router";
import { SharedModule } from "@shared/shared.module";
import { ProductCategoryDto } from "app/modules/masters/product-category/product-category.dto";
import { ProductCategoryService } from "app/modules/masters/product-category/product-category.service";
import { Observable } from "rxjs";

@Component({
  selector: "app-product-category-dropdown, [app-product-category-dropdown]",
  imports: [MatFormFieldModule, MatSelectModule, CommonModule, SharedModule],
  template: `
    <mat-form-field>
      <mat-select [value]="selectedProductCategoryCode()" [disabled]="idisabled()">
        @for (productCategory of $productCategoryObservable | async; track $index) {
          <mat-option [value]="productCategory.code" (click)="onProductCategoryChange(productCategory.code)">{{ productCategory.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  `,
  styleUrl: "./product-category-dropdown.component.scss",
})
export class ProductCategoryDropdownComponent {
  productCategoryService = inject(ProductCategoryService);
  __router = inject(Router);
  selectedProductCategoryCode = signal<string>("");

  $productCategoryObservable: Observable<ProductCategoryDto[]> = this.productCategoryService.getLoggedInUserProductCategory();

  idisabled = input.required<boolean>();

  constructor() {
    this.productCategoryService.$selectedProductCategoryCode.subscribe((selectedProductCategoryCode) => {
      this.selectedProductCategoryCode.set(selectedProductCategoryCode);
    });
  }

  onProductCategoryChange(selectedValue: string): void {
    this.selectedProductCategoryCode.set(selectedValue);
    this.productCategoryService.publishProductCategory(selectedValue);
    this.__router.navigate([`/adaptive-ui-flow/list/`, btoa(selectedValue)]);
  }
}
